import React from 'react';
import { Box } from '@mui/material';
import useInView from './useInView';
import { color } from '../../theme/tokens';
import { LC, MOTION, r } from './landingTokens';

// ─── Evidence strength bars ───────────────────────────────────────────────────
// Five ascending graphite bars = study/evidence strength. Graphite + bar shape,
// kept visually distinct from the green EvidenceRing (Brand brief §5).
// With `animate`, the filled bars grow bottom-up one at a time on scroll-in
// (resetting when scrolled out); unfilled track bars stay static.
const HEIGHTS = [6, 9.5, 13, 16.5, 20];

export default function StrengthBars({ filled = 0, animate = false, sx }) {
  const [ref, inView, instant] = useInView();
  return (
    <Box
      ref={animate ? ref : undefined}
      sx={{ display: 'flex', gap: '0.156rem', alignItems: 'flex-end', height: r(20), ...sx }}
    >
      {HEIGHTS.map((h, i) => (
        <Box
          key={i}
          sx={{
            width: r(6),
            height: r(h),
            borderRadius: '0.094rem',
            display: 'block',
            background: i < filled ? LC.strengthBar : color.strengthEmpty,
            ...(animate && i < filled
              ? {
                  transformOrigin: 'bottom',
                  transform: inView ? 'scaleY(1)' : 'scaleY(0)',
                  transition: instant ? 'none' : `transform ${MOTION.durationSm}ms ${MOTION.ease} ${i * MOTION.stagger}ms`,
                  '@media (prefers-reduced-motion: reduce)': { transform: 'none', transition: 'none' },
                }
              : {}),
          }}
        />
      ))}
    </Box>
  );
}
